import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer } from '@angular/platform-browser';

import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/switchMap';

import { VideoPoster } from '../../models/videoposter';
import { TextItem } from '../../models/videoposter';
import { ClipartItem } from '../../models/videoposter';
import { Item } from '../../models/videoposter';
//import * as createjs from 'createjs-module';
import * as html2canvas from "html2canvas"

@Component({
  selector: 'app-drawing-board',
  templateUrl: './drawing-board.component.html',
  styleUrls: ['./drawing-board.component.scss']
})
export class DrawingBoardComponent implements OnInit {

  @Input()
  poster: VideoPoster;

  //@Output() drawingEvent = new EventEmitter<void>();

  private dragging = false;
  private resize = false;

  showWindow = false;

  private canvasBG : any;
  private position = {
    "x" : 0,
    "y" : 0
  }
  private canvasScale: number;
  private bgLoaded = false;


  constructor(private sanitizer: DomSanitizer) {

  }

  ngOnInit() {

  }

  ngAfterViewInit(){
    /*var textElems = document.getElementsByTagName("textarea");
    var i = 0;
    while(i < textElems.length){
      var item = this.poster.getItem(textElems[i].id);
      if(item){
        textElems[i].style.height = (<TextItem>item).innerHeight + "px";
      }
      i++;
    }*/
    var textElems = document.getElementsByTagName("textarea");
    var i = 0;
    while(i < textElems.length){
      var item = this.poster.getItem(textElems[i].id);
      if(item){
        textElems[i].style.height = textElems[i].scrollHeight + "px";
        (<TextItem>item).innerHeight = textElems[i].scrollHeight;
      }
      i++;
    }
  }

  ngAfterViewChecked(){
    var textElems = document.getElementsByTagName("textarea");
    var i = 0;
    while(i < textElems.length){
      var item = this.poster.getItem(textElems[i].id);
      if(item){
        textElems[i].style.height = textElems[i].scrollHeight + "px";
        (<TextItem>item).innerHeight = textElems[i].scrollHeight;
      }
      i++;
    }
  }

  getCanvasImage(){
    this.poster.removeItemSelected();

    return html2canvas(document.getElementById("drawing-canvas"), {'scale': 1/this.canvasScale, 'backgroundColor': null, 'removeContainer': false});
  }

  getPoster(){
    return this.poster;
  }

  backgroundLoaded(e: any): void{
    if(e.path){
      this.poster.width = e.path[0].width;
      this.poster.height = e.path[0].height;
    } else if (!!e.srcElement){
      this.poster.width = e.srcElement.naturalWidth;
      this.poster.height = e.srcElement.naturalHeight;
    }
    else{
      this.poster.width = e.target.naturalWidth;
      this.poster.height = e.target.naturalHeight;
    }
    this.onWindowResize();
    this.bgLoaded = true;
  }

  isItemText(item: any): boolean{
    return item instanceof TextItem;
  }

  isItemClipart(item: any): boolean{
    if(!item.imagePreview){
      item.imagePreview = this.sanitizer.bypassSecurityTrustUrl(item.imageUrl);
    }
    return item instanceof ClipartItem;
  }

  posterMouseDown(e: any): void{
    e.stopPropagation();
    if(e instanceof MouseEvent){
      this.position["x"] = e.clientX;
      this.position["y"] = e.clientY;
    } else if(e instanceof TouchEvent){
      this.position["x"] = e.changedTouches[0].clientX;
      this.position["y"] = e.changedTouches[0].clientY;
    }
    this.poster.removeItemSelected();
  }

  posterMouseMove(e: MouseEvent): void{

  }

  posterMouseUp(e: any): void{
    e.stopPropagation();
    this.dragging = false;
    this.resize = false;
    //this.drawingEvent.emit();
  }

  dragMouseDown(e: any): void{
    e.stopPropagation();
    //this.poster.removeItemSelected();
    this.dragging = true;
    if(e instanceof MouseEvent){
      this.position["x"] = e.clientX;
      this.position["y"] = e.clientY;
    } else if(e instanceof TouchEvent){
      this.position["x"] = e.changedTouches[0].clientX;
      this.position["y"] = e.changedTouches[0].clientY;
    }

  }

  dragMouseUp(e: any): void{
    e.stopPropagation();
    this.dragging = false;
    this.resize = false;
    //this.drawingEvent.emit();
  }

  resizeMouseDown(e: any): void{
    e.stopPropagation();
    //this.poster.removeItemSelected();
    this.resize = true;
    if(e instanceof MouseEvent){
      this.position["x"] = e.clientX;
      this.position["y"] = e.clientY;
    } else if(e instanceof TouchEvent){
      this.position["x"] = e.changedTouches[0].clientX;
      this.position["y"] = e.changedTouches[0].clientY;
    }
  }

  resizeMouseUp(e: any): void{
    e.stopPropagation();
    this.dragging = false;
    this.resize = false;
    //this.drawingEvent.emit();
  }

  itemMouseDown(e: any): void{
    e.stopPropagation();
    this.poster.setItemSelected(e.target.id);
  }

  itemMouseUp(e: any): void{
    e.stopPropagation();
    this.dragging = false;
    this.resize = false;
    //this.drawingEvent.emit();
  }

  onTextChange(c: any): void{
    var item = this.poster.getItemSelected();
    if(!!item && item instanceof TextItem){
      (<TextItem>item).setContent(c);
    }
    //this.drawingEvent.emit();
  }

  adjustTextAreaHeight(event: any){
    var item = this.poster.getItemSelected();
    if(!!item && item instanceof TextItem){
      (<TextItem>item).setContent(event.target.value);
    }
    if(!!event.srcElement){
      event.srcElement['style']['height'] = event.srcElement.scrollHeight + "px";
      (<TextItem>item).innerHeight = event.srcElement.scrollHeight;
    }
    else{
      event.target['style']['height'] = event.target.scrollHeight + "px";
      (<TextItem>item).innerHeight = event.target.scrollHeight;
    }

  }

  preventDragOnText(event: any){
    if(event.type=='dragenter' || event.type=='dragover' || //if drag over event -- allows for drop event to be captured, in case default for this is to not allow drag over target
      event.type=='drop') //prevent text dragging -- IE and new Mozilla (like Firefox 3.5+)
    {
      if(event.stopPropagation) //(Mozilla)
      {
        event.preventDefault();
        event.stopPropagation(); //prevent drag operation from bubbling up and causing text to be modified on old Mozilla (before Firefox 3.5, which doesn't have drop event -- this avoids having to capture old dragdrop event)
      }
      return false; //(IE)
    }
  }

  getDrawingCanvasWidth(){return Math.round(this.poster.getWidth()*this.canvasScale);}
  getDrawingCanvasHeight(){return Math.round(this.poster.getHeight()*this.canvasScale);}
  getCanvasItemLeft(item: any){return Math.round(item.getLeft()*this.canvasScale);}
  getCanvasItemTop(item: any){return Math.round(item.getTop()*this.canvasScale);}
  getCanvasItemWidth(item: any){return Math.round(item.getWidth()*this.canvasScale);}
  getCanvasItemHeight(item: any){return Math.round(item.getHeight()*this.canvasScale);}
  getCanvasFontSize(item:any){return Math.round(item.getFontSize()*this.canvasScale);}

  @HostListener('window:resize', ['$event'])
  onWindowResize(e?: any) {
    const avail = {
      "width": window.innerWidth - (window.innerWidth*.33) - 100, // Sidebar is 25% window width, as defined in _variables.scss
      "height": window.innerHeight - 100 // canvas margin-y = 50px
    }
    this.canvasScale = 1;
    if (this.poster.width*this.canvasScale > avail.width) this.canvasScale = avail.width/this.poster.width;
    if (this.poster.height*this.canvasScale > avail.height) this.canvasScale = avail.height/this.poster.height;
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(e: any): void{
    if(e instanceof MouseEvent){
      this.position["x"] = e.clientX;
      this.position["y"] = e.clientY;
    } else if(e instanceof TouchEvent){
      this.position["x"] = e.changedTouches[0].clientX;
      this.position["y"] = e.changedTouches[0].clientY;
    }
    this.poster.removeItemSelected();
    // TODO: if item was text, close text properties panel in body/sidebar
  }

  @HostListener('mouseup', ['$event'])
  onMouseUp(e: any): void{
    this.dragging = false;
    this.resize = false;
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(e: MouseEvent): void{
    var dx = (e.clientX - this.position["x"])/this.canvasScale;
    var dy = (e.clientY - this.position["y"])/this.canvasScale;
    var pw = this.poster.getWidth(), ph = this.poster.getHeight();
    if(this.dragging){
      var item = this.poster.getItemSelected();
      if(!!item){
        var iw = item.getWidth(), ih = item.getHeight(),nx = item.getLeft() + dx, ny = item.getTop() + dy;
        if(nx < 0) nx =0;
        if(nx + iw > pw) nx = pw - iw;
        if(ny < 0) ny = 0;
        if(ny + ih > ph) ny = ph - ih;
        item.setLeft(nx);
        item.setTop(ny);
      } else{
        this.dragging = false;
      }
      this.position["x"] = e.clientX;
      this.position["y"] = e.clientY;
    } else if(this.resize){
      var item = this.poster.getItemSelected();
      if(!!item){
        var ix = item.getLeft(), iy = item.getTop(),nw = item.getWidth() + dx, nh = item.getHeight() + dy;
        if(nw < 5) nw = 5;
        if(ix + nw > pw) nw = pw - ix;
        if(nh < 5) nh = 5;
        if(iy + nh > ph) nh = ph - iy;
        item.setWidth(nw);
        item.setHeight(nh);
        if(item instanceof TextItem){
          var idom = document.getElementById(item.getId());
          idom.style.height = idom.scrollHeight + "px";
        }
      } else{
        this.resize = false;
      }
      this.position["x"] = e.clientX;
      this.position["y"] = e.clientY;
    }
  }

  posterTouchMove(e: TouchEvent){
    e.stopPropagation();
    e.preventDefault();
    var dx = (e.changedTouches[0].clientX - this.position["x"])/this.canvasScale;
    var dy = (e.changedTouches[0].clientY - this.position["y"])/this.canvasScale;
    var pw = this.poster.getWidth(), ph = this.poster.getHeight();
    if(this.dragging){
      var item = this.poster.getItemSelected();
      if(!!item){
        var iw = item.getWidth(), ih = item.getHeight(),nx = item.getLeft() + dx, ny = item.getTop() + dy;
        if(nx < 0) nx =0;
        if(nx + iw > pw) nx = pw - iw;
        if(ny < 0) ny = 0;
        if(ny + ih > ph) ny = ph - ih;
        item.setLeft(nx);
        item.setTop(ny);
      } else{
        this.dragging = false;
      }
      this.position["x"] = e.changedTouches[0].clientX;
      this.position["y"] = e.changedTouches[0].clientY;
    } else if(this.resize){
      var item = this.poster.getItemSelected();
      if(!!item){
        var ix = item.getLeft(), iy = item.getTop(),nw = item.getWidth() + dx, nh = item.getHeight() + dy;
        if(nw < 5) nw = 5;
        if(ix + nw > pw) nw = pw - ix;
        if(nh < 5) nh = 5;
        if(iy + nh > ph) nh = ph - iy;
        item.setWidth(nw);
        item.setHeight(nh);
      } else{
        this.resize = false;
      }
      this.position["x"] = e.changedTouches[0].clientX;
      this.position["y"] = e.changedTouches[0].clientY;
    }
  }

  ngOnDestroy() {
    //this.getCanvasImage();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/drawing-board/drawing-board.component.ts